import { render, staticRenderFns } from "./Advertencias.vue?vue&type=template&id=58b633c4&"
import script from "./Advertencias.vue?vue&type=script&lang=js&"
export * from "./Advertencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports